function initMask(context) {
  var options = {
    autoUnmask: true,
    clearIncomplete: true,
    showMaskOnHover: false,
    removeMaskOnSubmit: true,
    rightAlign: false
  }
  var mask = "+1 (999) 999-9999 [ext. 9{0,4}]";
  $('[type="tel"]').inputmask({
    ...options,
    greedy: true,
    mask
  });
  $('.tel', context).inputmask(mask);

  $('.datemask', context).inputmask({
    ...options,
    mask: '99/99/9999',
    placeholder: 'MM/DD/YYYY',
  });

  $('.currency', context).inputmask({
    ...options,
    alias: 'currency',
    prefix: '$'
  });

  $(".numeric", context).inputmask({
    ...options,
    alias: 'numeric',
    allowMinus: false,
    digits: 2
  });

  const area_mask_options = {
    alias: 'decimal',
    groupSeparator: ',',
    autoGroup: true,
    digitsOptional: true
  }

  $(".sqft_mask", context).inputmask({
    ...area_mask_options,
    digits: 0
  });

  $(".acres_mask", context).inputmask({
    ...area_mask_options,
    digits: 2
  });
}


global.modules.set({
  async init(context) {
    initMask(context);
  }
})